import React from 'react';
import Calendar from '../components/Calendar'; // path points to your existing Calendar component

const CalendarPage = () => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Game Release Calendar</h1>
      <Calendar />
    </div>
  );
};

export default CalendarPage;
